export default "__VITE_ASSET__Cxh2R69g__"